export default __webpack_public_path__ + "static/media/dashboard-color.e09e8503.svg";